import React from "react"
import { FunctionComponent } from "react"
import { IconContext } from "react-icons/lib"
import { TbUsersGroup, TbBuildingBank, TbMessages } from "react-icons/tb"
import { RiCalendarEventFill } from "react-icons/ri"
import { LuPencilRuler } from "react-icons/lu"

interface CategoryIconsProps {
	categoryId: number
}

const CategoryIcons: FunctionComponent<CategoryIconsProps> = ({ categoryId }) => {

	const icon = (categoryId: number) => {
		switch (categoryId) {
			case 1:
				return (
					<IconContext.Provider value={{ className: "categoryview-icon" }}>
						<TbUsersGroup />
					</IconContext.Provider>
				)
			case 2:
				return (
					<IconContext.Provider value={{ className: "categoryview-icon" }}>
						<TbBuildingBank />
					</IconContext.Provider>
				)
			case 3:
				return (
					<IconContext.Provider value={{ className: "categoryview-icon" }}>
						<RiCalendarEventFill />
					</IconContext.Provider>
				)
			case 4:
				return (
					<IconContext.Provider value={{ className: "categoryview-icon" }}>
						<LuPencilRuler />
					</IconContext.Provider>
				)
			case 5:
				return (
					<IconContext.Provider value={{ className: "categoryview-icon" }}>
						<TbMessages />
					</IconContext.Provider>
				)
			default:
				return null
		}
	}

	return <>{icon(categoryId)}</>
}

export default CategoryIcons
